/* Lee los proyectos del portafolio desde Firestore (colección "projects") vía la API REST.
   Firestore es la fuente de las imágenes y los enlaces; los textos vienen del design system (content/home.js). */
import { useEffect, useState } from "react";

const PROJECT_ID = "portafolio-2d59e";
// Clave web pública de Firebase (no es un secreto: el acceso lo controlan las reglas de Firestore).
const API_KEY = "AIzaSyDq1gqTOSLuTrh__jCAFfqbPoBCJdY90n4";
const ENDPOINT = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents/projects?pageSize=100&key=${API_KEY}`;

// Proyecto del diseño → id del documento en Firestore.
const DOC_IDS = {
  roperito: "roperito",
  tenapp: "tenapp",
  checkauto: "ckbn3xLDEhJLqueS7IYe",
  roam: "LTfkyUIMQmqVkAjCUO8j",
  bullrunfrenzy: "bullrunfrenzy",
  mammamia: "mamamia",
};

// Proyectos cuyas capturas son de la ventana completa (pestañas de Chrome arriba, barra de Windows abajo):
// el sitio las recorta con la clase .is-window-capture (styles/app.css).
const WINDOW_CAPTURES = new Set(["roperito"]);

const fromValue = (v) => {
  if (!v) return undefined;
  if ("arrayValue" in v) return (v.arrayValue.values || []).map(fromValue);
  if ("mapValue" in v) return fromFields(v.mapValue.fields);
  if ("integerValue" in v) return Number(v.integerValue);
  return Object.values(v)[0];
};
const fromFields = (fields = {}) =>
  Object.fromEntries(Object.entries(fields).map(([k, v]) => [k, fromValue(v)]));

// Normaliza un documento: los campos vacíos ("") quedan como undefined para no generar enlaces muertos.
const toProject = (doc) => {
  const d = fromFields(doc.fields);
  const str = (s) => (typeof s === "string" && s.trim() ? s.trim() : undefined);
  return {
    name: d.nombre,
    cover: str(d.portada),
    images: (d.imagenes || []).filter(str),
    github: str(d.github),
    site: str(d.pages),
    // "store" puede ser un texto (una tienda) o un arreglo (p. ej. Steam y Google Play).
    stores: [].concat(d.store || []).map(str).filter(Boolean),
  };
};

let cache = null;

async function fetchProjects() {
  if (!cache) {
    cache = fetch(ENDPOINT)
      .then((r) => {
        if (!r.ok) throw new Error(`Firestore respondió ${r.status}`);
        return r.json();
      })
      .then((json) => {
        const byDocId = Object.fromEntries((json.documents || []).map((doc) => [doc.name.split("/").pop(), toProject(doc)]));
        return Object.fromEntries(Object.entries(DOC_IDS).map(([key, id]) => [
          key,
          byDocId[id] ? { ...byDocId[id], windowCapture: WINDOW_CAPTURES.has(key) } : {},
        ]));
      })
      .catch((err) => {
        cache = null; // permite reintentar en la siguiente carga
        throw err;
      });
  }
  return cache;
}

/* Devuelve { roperito, tenapp, ... } con { cover, images, github, site, stores }.
   Mientras carga (o si falla) devuelve objetos vacíos y la página muestra los MockScreen del diseño. */
export function useProjects() {
  const [projects, setProjects] = useState(() => Object.fromEntries(Object.keys(DOC_IDS).map((k) => [k, {}])));
  useEffect(() => {
    let alive = true;
    fetchProjects()
      .then((p) => alive && setProjects(p))
      .catch((err) => console.error("No se pudieron cargar los proyectos desde Firestore:", err));
    return () => { alive = false; };
  }, []);
  return projects;
}

// "https://roperitoweb.netlify.app/" → "roperitoweb.netlify.app" (texto de la barra del BrowserFrame).
export const hostOf = (url) => {
  try { return new URL(url).host; } catch (e) { return undefined; }
};
